import { Select } from '@cfa/react-core';

import { cn } from '@/utils/tailwind';

export interface DropdownWithTitleProps<
  T extends {
    id: string;
  } = { id: string },
> {
  label?: string;
  value?: NoInfer<T>;
  options?: T[];
  displayKey?: keyof T;
  onSelectionChange?: (value: NoInfer<T>) => void;
  className?: string;
  containerClassName?: string;
  labelClassName?: string;
}

const DropdownWithTitle = <T extends { id: string }>({
  label,
  onSelectionChange,
  options = [],
  value,
  displayKey = 'id',
  className = '',
  containerClassName = '',
  labelClassName = '',
}: DropdownWithTitleProps<T>): React.ReactElement => (
  <div
    className={cn(
      'flex flex-col flex-wrap gap-2 sm:flex-row sm:items-center',
      containerClassName,
    )}
  >
    {label && (
      <p className={cn('text-variant-body1 text-left', labelClassName)}>
        {label}:
      </p>
    )}
    <Select.Root
      className={cn('w-[160px]', className)}
      defaultSelectedKey={value?.id}
      selectedKey={value?.id}
      onSelectionChange={key => {
        const option = options.find(option => option.id === key);
        if (option) {
          onSelectionChange?.(option);
        }
      }}
    >
      <Select.Button className={className}>
        <Select.Value />
      </Select.Button>
      <Select.Popover>
        <Select.List>
          {options.map(option => (
            <Select.Item key={option.id} id={option.id}>
              {String(option[displayKey])}
            </Select.Item>
          ))}
        </Select.List>
      </Select.Popover>
    </Select.Root>
  </div>
);

export default DropdownWithTitle;
